var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',[_c('page-header',{attrs:{"title":"Crear descuento","back-to":"/descuentos"}}),_c('formulario',{attrs:{"descuento":_vm.descuento},on:{"submit":_vm.insertar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }